import onepass_model from "@iscr/models/onepass_model";
import { useUser } from "@iscr/xAppLib/Hooks";
import { useAsync } from "@iscr/xAppLib/Hooks/useAsync";
import API_service from "@iscr/xAppLib/providers/API_service";

/**
 * @param {boolean=true} enabled
 * @return {UseAsyncResult<boolean>}
 */
export function useOnePassEligibility(enabled = true) {
	// OnePass can only be linked to the parent profile. So while the existing solution uses the _active_ profile,
	// that's actually defective if we were to somehow load a child profile from the get-go (which I _think_ is meant to
	// be possible, but doesn't actually work properly). If we're supposed to not give discounts to child profiles, then
	// this will need to change to take the active profile.

	const user = useUser();
	const token = user?.prof?.onepass;

	const checkUser = useAsync({
		immediate: enabled && token && onepass_model.isValidOnepassMember(),
		fn: async () => await API_service.load_data("User/myOnepass", { token }),
	}, [token]);

	return {
		...checkUser,
		data: Boolean(checkUser.data) ?? false,
	}
}